(function () {
  if (window.location.pathname.replace(/\/+$/, "") !== "/collections/euphoria") return;

  const MODULE_ID = "hue-single-review-module";
  const HUE_PRODUCT_ID = "hm-euphoria-collection";
  // Match the Euphoria featured-collection section by its stable JSON key suffix
  // (`__featured_collection_qxbBQR`) rather than the theme-specific template id,
  // which differs between the dev copy and the live theme.
  const GRID_SELECTOR = '[id^="shopify-section-template--"][id$="__featured_collection_qxbBQR"] .product-grid';
  const CARD_SELECTOR = "product-block";

  const MOBILE_AFTER = 2;
  const DESKTOP_AFTER = 3; // after 3rd product = 4th item in first row

  const isMobile = () => window.innerWidth <= 767;

  function getGrid() {
    return document.querySelector(GRID_SELECTOR);
  }

  function getCards(grid) {
    return grid ? Array.from(grid.querySelectorAll(CARD_SELECTOR)) : [];
  }

  function desiredAfterIndex() {
    return isMobile() ? MOBILE_AFTER : DESKTOP_AFTER;
  }

  function ensureModuleEl() {
    let el = document.getElementById(MODULE_ID);

    if (!el) {
      el = document.createElement("div");
      el.id = MODULE_ID;
      el.className = "hue-module";
    }

    el.dataset.productId = HUE_PRODUCT_ID;

    return el;
  }

  function placeModule() {
    const grid = getGrid();
    if (!grid) return false;

    const cards = getCards(grid);
    if (!cards.length) return false;

    const moduleEl = ensureModuleEl();
    const idx = desiredAfterIndex();
    const afterEl = cards.length >= idx ? cards[idx - 1] : cards[cards.length - 1];

    if (moduleEl.parentNode === grid && moduleEl.previousSibling === afterEl) return true;

    afterEl.after(moduleEl);

    return true;
  }

  let t = null;

  function schedulePlace() {
    clearTimeout(t);
    t = setTimeout(placeModule, 120);
  }

  function retryInitial(maxTries, delayMs) {
    let tries = 0;

    (function tick() {
      tries += 1;
      if (placeModule()) return;
      if (tries >= maxTries) return;
      setTimeout(tick, delayMs);
    })();
  }

  function startObserver() {
    const mo = new MutationObserver(schedulePlace);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  let lastMobile = isMobile();

  window.addEventListener(
    "resize",
    () => {
      const nowMobile = isMobile();

      if (nowMobile !== lastMobile) {
        lastMobile = nowMobile;
        schedulePlace();
      }
    },
    { passive: true }
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      retryInitial(60, 100);
      startObserver();
    });
  } else {
    retryInitial(60, 100);
    startObserver();
  }

  document.addEventListener("hue-add-to-cart", (e) => {
    const variantId = e?.detail?.variantId;
    if (!variantId) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
  });
})();